var _circle, _path, _circle2, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIncreaseIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 56,
    r: 56,
    fill: "#F6F9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 56C10.5 66.1089 13.8664 75.93 20.068 83.9132C26.2696 91.8963 34.9531 97.5869 44.7481 100.087C54.543 102.587 64.8916 101.753 74.1604 97.7187C83.4292 93.6839 91.0904 86.6774 95.9349 77.8049C100.779 68.9324 102.531 58.6992 100.914 48.7205C99.2966 38.7418 94.4022 29.5858 87.0033 22.6977C79.6044 15.8095 70.1223 11.5815 60.0535 10.6809C49.9848 9.78034 39.9029 12.2585 31.399 17.7242L38.2873 28.4414C44.4101 24.5061 51.6691 22.7218 58.9185 23.3703C66.168 24.0187 72.9952 27.0629 78.3224 32.0223C83.6496 36.9818 87.1735 43.5741 88.338 50.7588C89.5025 57.9434 88.2412 65.3113 84.7531 71.6995C81.2651 78.0877 75.749 83.1324 69.0755 86.0375C62.4019 88.9425 54.951 89.5424 47.8986 87.7425C40.8463 85.9426 34.5941 81.8453 30.129 76.0975C25.6638 70.3496 23.24 63.2784 23.24 56L10.5 56Z",
    fill: "url(#paint0_angular_1351_27255)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.0003,
    cy: 56.0023,
    r: 16.3333,
    fill: "#A685EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3073 44.4316L48.5137 57.4473H54.4777L49.5698 67.5705L63.4859 53.745H58.5159L63.3073 44.4316Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.624 16.8858C49.624 26.2115 32.687 45.5182 32.687 45.5182C32.687 45.5182 15.75 26.2115 15.75 16.8858C15.75 7.56002 23.333 0 32.687 0C42.041 0 49.624 7.56002 49.624 16.8858Z",
    fill: "#FBD07E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8062 16.4817L32.6868 9.52539L39.5675 16.4817H37.5033V21.6989H27.8703V16.4817H25.8062Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_1351_27255",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56 56) rotate(-176.855) scale(57.9964 57.3921)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DE0A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515798,
    stopColor: "#6DE0A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F9FF",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncreaseIcon1);
export default __webpack_public_path__ + "static/media/increaseIcon1.1f2aa264b3e8afc29de306aabfd14985.svg";
export { ForwardRef as ReactComponent };